import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base/base.service';
@Injectable({
  providedIn: 'root',
})
export class OrderService extends BaseService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  createOrder(body: any) {
    const URI = 'orders';

    return this.post(URI, body);
  }

  //implemets update order
  updateOrder(id: string, body: any) {
    const URI = `orders/${id}`;

    return this.put(URI, body);
  }

  getOrdersByUser(options?: any) {
    const URI = 'orders';
    const sort = `&sort={"${options?.sort.sortBy}":"${options?.sort.order}"}&page=${options?.sort.page}&limit=10`;

    const filter = '?filters='; // Implement filter strategy here

    return this.get(URI + filter + sort);
  }
}
